import { i as rt, h as g, _ as E, m as yt, d as xt, n as Wt, r as Et, e as et, s as _t, k as dt, b as Z, t as St, o as xr } from "./main-zRUwk2ge.mjs";
import { E as Pt } from "./export_load_panel-C1_JdN4s.mjs";
function mt(t) {
  var r, e, a, n;
  return rt(t) ? {
    top: t,
    right: t,
    bottom: t,
    left: t
  } : {
    top: (r = t == null ? void 0 : t.top) !== null && r !== void 0 ? r : 0,
    right: (e = t == null ? void 0 : t.right) !== null && e !== void 0 ? e : 0,
    bottom: (a = t == null ? void 0 : t.bottom) !== null && a !== void 0 ? a : 0,
    left: (n = t == null ? void 0 : t.left) !== null && n !== void 0 ? n : 0
  };
}
function Dt(t) {
  t.forEach((r) => {
    r.cells.forEach((e) => {
      var {
        pdfCell: a
      } = e;
      a.padding = mt(a.padding);
    });
  });
}
var I = "...";
function U(t, r) {
  var e = 1 / t.internal.scaleFactor;
  return r * e;
}
function at(t) {
  return t.internal.pageSize.getWidth();
}
function Lt(t) {
  return t.internal.pageSize.getHeight();
}
function nt(t, r, e, a) {
  var {
    wordWrapEnabled: n,
    targetRectWidth: o
  } = a;
  if (n) {
    var i = t.getFont(e == null ? void 0 : e.name, e == null ? void 0 : e.style);
    return t.splitTextToSize(r, o, {
      fontSize: (e == null ? void 0 : e.size) || t.getFontSize(),
      fontName: i.fontName,
      fontStyle: i.fontStyle
    });
  }
  var l = r.split(`
`).filter((v) => v !== "").join(" ");
  if (M(t, l, e).w <= o)
    return [l];
  for (var d = M(t, l + I, e).w; l.length > 0 && d > o; ) {
    var s = 0;
    d >= 2 * o && (s = l.length / 2), s < 1 && (s = 1), l = l.substring(0, l.length - s), d = M(t, l + I, e).w;
  }
  return [l + I];
}
function ot(t, r) {
  var e = t - (r.left + r.right);
  return e >= 0 ? e : 0;
}
function M(t, r, e) {
  return t.getTextDimensions(r, {
    font: t.getFont(e == null ? void 0 : e.name, e == null ? void 0 : e.style),
    fontSize: (e == null ? void 0 : e.size) || t.getFontSize()
  });
}
function k(t, r, e, a) {
  var {
    wordWrapEnabled: n,
    targetRectWidth: o
  } = a, i = M(t, r, e).h, l = nt(t, r, e, {
    wordWrapEnabled: n,
    targetRectWidth: o
  }).length;
  return i * l * t.getLineHeightFactor();
}
function Ft(t, r, e) {
  if (r.length !== e.length)
    throw "the cells count must be equal to the count of the columns";
  for (var a = 0, n = 0; n < r.length; n++)
    if (!g(r[n].rowSpan)) {
      var o = r[n].pdfCell.text, i = r[n].pdfCell.padding, l = r[n].pdfCell.font, d = r[n].pdfCell.wordWrapEnabled, s = e[n], v = ot(s, i);
      if (g(o)) {
        var u = o !== "" ? k(t, o, l, {
          wordWrapEnabled: d,
          targetRectWidth: v
        }) : 0, p = u + i.top + i.bottom;
        a < p && (a = p);
      }
    }
  return a;
}
function Ot(t, r) {
  r.forEach((e) => {
    e.cells.forEach((a) => {
      var {
        pdfCell: n
      } = a;
      if (g(n.text)) {
        var o = nt(t, n.text, n.font, {
          wordWrapEnabled: n.wordWrapEnabled,
          targetRectWidth: ot(n._rect.w, n.padding)
        });
        n.text = o.join(`
`);
      }
    });
  });
}
function Rt(t, r, e) {
  r.forEach((a) => {
    a.forEach((n) => {
      var o = at(t) - (n._rect.x + n._rect.w), i = e.margin.left - e.margin.right;
      n._rect.x = o + i;
    });
  });
}
var vt = (t, r) => t + r;
function At(t, r, e, a, n) {
  var o = r.getColumnsWidths().map((v) => U(t, v ?? 150)), i = o.filter((v, u) => !g(n[u])).reduce(vt, 0), l = n.filter((v) => rt(v)).reduce(vt, 0), d = zt(t, e, a), s = l < d ? (d - l) / i : 1;
  return o.map((v, u) => {
    var p;
    return (p = n[u]) !== null && p !== void 0 ? p : v * s;
  });
}
function zt(t, r, e) {
  return at(t) - r - e.left - e.right;
}
function Bt(t, r, e, a) {
  var n = At(t, r, a.topLeft.x, a.margin, a.columnWidths);
  e.forEach((o) => {
    o.cells.forEach((i, l) => {
      var {
        gridCell: d,
        pdfCell: s
      } = i;
      s._rect.w = n[l];
    });
  });
}
function Tt(t, r, e) {
  r.forEach((a) => {
    var n = a.cells.map((l) => l.pdfCell), o;
    if (e.onRowExporting) {
      var i = {
        rowCells: n
      };
      e.onRowExporting(i), g(i.rowHeight) && (o = i.rowHeight);
    }
    a.height = g(o) ? o : Ft(t, a.cells, n.map((l) => l._rect.w)), n.forEach((l) => {
      l._rect.h = a.height;
    });
  });
}
function Ht(t) {
  for (var r = 0; r < t.length; r++)
    for (var e = t[r], a = 0; a < e.cells.length; a++) {
      var n = e.cells[a];
      if (g(n.colSpan) && !g(n.pdfCell.isMerged))
        for (var o = 1; o <= n.colSpan; o++) {
          var i = t[r].cells[a + o];
          n.pdfCell._rect.w += i.pdfCell._rect.w, i.pdfCell._rect.w = 0, i.pdfCell.isMerged = !0;
        }
    }
}
function jt(t) {
  for (var r = 0; r < t.length; r++)
    for (var e = t[r], a = 0; a < e.cells.length; a++) {
      var n = e.cells[a];
      if (g(n.rowSpan) && !g(n.pdfCell.isMerged))
        for (var o = 1; o <= n.rowSpan; o++) {
          var i = t[r + o].cells[a];
          n.pdfCell._rect.h += i.pdfCell._rect.h, i.pdfCell._rect.h = 0, i.pdfCell.isMerged = !0;
        }
    }
}
function Gt(t, r) {
  t.forEach((e) => {
    e.cells[0].pdfCell._rect.w -= e.indentLevel * r.indent;
  });
}
function Mt(t) {
  for (var r = 0; r < t.length; r++)
    for (var e = t[r].cells, a = 0; a < e.length; a++) {
      var n = e[a].pdfCell, o = a >= 1 ? e[a - 1].pdfCell : null, i = r >= 1 ? t[r - 1].cells[a].pdfCell : null;
      n.drawLeftBorder === !1 && !g(e[a].colSpan) ? g(o) && (o.drawRightBorder = !1) : g(n.drawLeftBorder) || g(o) && o.drawRightBorder === !1 && (n.drawLeftBorder = !1), n.drawTopBorder === !1 ? g(i) && (i.drawBottomBorder = !1) : g(n.drawTopBorder) || g(i) && i.drawBottomBorder === !1 && (n.drawTopBorder = !1);
    }
}
function kt(t, r, e) {
  var a, n = e == null ? void 0 : e.topLeft, o = e == null ? void 0 : e.margin, i = ((a = n == null ? void 0 : n.y) !== null && a !== void 0 ? a : 0) + o.top;
  r.forEach((l) => {
    var d, s = ((d = n == null ? void 0 : n.x) !== null && d !== void 0 ? d : 0) + o.left, v = l.indentLevel * e.indent;
    l.cells.forEach((u) => {
      u.pdfCell._rect.x = s + v, u.pdfCell._rect.y = i, s += u.pdfCell._rect.w;
    }), i += l.height;
  });
}
function Nt(t, r, e) {
  var a, n, o, i, l, d, s, v, u, p;
  r.forEach((b) => {
    (!g(s) || s > b._rect.x) && (s = b._rect.x), (!g(v) || v > b._rect.y) && (v = b._rect.y), (!g(u) || u < b._rect.x + b._rect.w) && (u = b._rect.x + b._rect.w), (!g(p) || p < b._rect.y + b._rect.h) && (p = b._rect.y + b._rect.h);
  });
  var h = (a = (n = s) !== null && n !== void 0 ? n : e == null || (o = e.topLeft) === null || o === void 0 ? void 0 : o.x) !== null && a !== void 0 ? a : 0, m = (i = (l = v) !== null && l !== void 0 ? l : e == null || (d = e.topLeft) === null || d === void 0 ? void 0 : d.y) !== null && i !== void 0 ? i : 0, y = g(u) ? u - h : 0, _ = g(p) ? p - m : 0;
  return {
    x: h,
    y: m,
    w: y,
    h: _
  };
}
function qt(t, r) {
  var e = Vt(t, r);
  r.forEach((a) => {
    a.height += e[a.rowIndex];
  }), r.forEach((a) => {
    a.cells.forEach((n) => {
      var o, i = ((o = n.rowSpan) !== null && o !== void 0 ? o : 0) + 1;
      n.pdfCell._rect.h = r.slice(a.rowIndex, a.rowIndex + i).reduce((l, d) => l + d.height, 0);
    });
  });
}
function Vt(t, r) {
  var e = Array.from({
    length: r.length
  }, () => 0), a = Ut(r);
  return a.forEach((n) => {
    var o = n.cells.filter((i) => g(i.rowSpan));
    o.forEach((i) => {
      var l = ot(i.pdfCell._rect.w, i.pdfCell.padding), d = k(t, i.pdfCell.text, i.pdfCell.font, {
        wordWrapEnabled: i.pdfCell.wordWrapEnabled,
        targetRectWidth: l
      }), s = d + i.pdfCell.padding.top + i.pdfCell.padding.bottom, v = i.rowSpan + 1, u = r.slice(n.rowIndex, n.rowIndex + v).reduce((m, y) => m + y.height + e[y.rowIndex], 0);
      if (s > u)
        for (var p = (s - u) / v, h = n.rowIndex; h < n.rowIndex + v; h++)
          e[h] += p;
    });
  }), e;
}
function Ut(t) {
  var r = (e) => {
    var a = e.cells.map((n) => {
      var o;
      return (o = n.rowSpan) !== null && o !== void 0 ? o : 0;
    });
    return Math.max(...a);
  };
  return [...t].sort((e, a) => {
    var n = r(e), o = r(a);
    return n > o ? 1 : o > n ? -1 : 0;
  });
}
var $ = {
  base: {
    font: {
      size: 10
    },
    borderWidth: 0.5,
    borderColor: "#979797"
  },
  header: {
    textColor: "#979797"
  },
  group: {},
  data: {},
  groupFooter: {},
  totalFooter: {}
};
function Xt(t, r, e, a) {
  for (var n = [], o = r.getRowsCount(), i = !!e.option("wordWrapEnabled"), l = !!e.option("rtlEnabled"), d = r.getColumns(), s = r.getStyles(), v = 0; v < o; v++) {
    var u = r.getCellData(v, 0, !0).cellSourceData.rowType, p = u !== "header" ? r.getGroupLevel(v) : 0, h = n[v - 1];
    u === "groupFooter" && (h == null ? void 0 : h.rowType) === "groupFooter" && (p = h.indentLevel - 1), n.push({
      rowType: u,
      indentLevel: p,
      cells: Yt({
        doc: t,
        dataProvider: r,
        rowIndex: v,
        wordWrapEnabled: i,
        columns: d,
        styles: s,
        rowType: u,
        backgroundColor: u === "header" ? a : void 0,
        rtlEnabled: l
      }),
      rowIndex: v
    });
  }
  return n;
}
function Yt(t) {
  for (var {
    doc: r,
    dataProvider: e,
    rowIndex: a,
    wordWrapEnabled: n,
    columns: o,
    styles: i,
    rowType: l,
    backgroundColor: d,
    rtlEnabled: s
  } = t, v = [], u = 0; u < o.length; u++) {
    var p, h = e.getCellData(a, u, !0), m = i[e.getStyleId(a, u)], y = Kt(o[u], l, m), _ = s ? "right" : "left", b = U(r, 5), x = {
      text: Qt(h.value, m.format),
      verticalAlign: "middle",
      horizontalAlign: (p = y.alignment) !== null && p !== void 0 ? p : _,
      wordWrapEnabled: n,
      backgroundColor: d,
      padding: {
        top: b,
        right: b,
        bottom: b,
        left: b
      },
      _rect: {},
      _internalTextOptions: {}
    };
    s && (x._internalTextOptions.isInputVisual = !1, x._internalTextOptions.isOutputVisual = !0, x._internalTextOptions.isInputRtl = !0, x._internalTextOptions.isOutputRtl = !1);
    var w = {
      gridCell: h.cellSourceData,
      pdfCell: E({}, x, y)
    };
    if (l === "header") {
      var f = e.getCellMerging(a, u);
      f && f.rowspan > 0 && (w.rowSpan = f.rowspan), f && f.colspan > 0 && (w.colSpan = f.colspan);
    } else if (l === "group") {
      var c = s ? "drawRightBorder" : "drawLeftBorder", W = s ? "drawLeftBorder" : "drawRightBorder";
      if (w.pdfCell[c] = u === 0, w.pdfCell[W] = u === o.length - 1, u > 0) {
        var L = v.slice(1).reduce((B, O) => B && !g(O.pdfCell.text), !0);
        if (!g(w.pdfCell.text) && L) {
          v[0].pdfCell[W] = !0;
          for (var S = 0; S < v.length; S++)
            v[S].colSpan = v.length;
          w.colSpan = v.length;
        }
      }
    }
    v.push(w);
  }
  return v;
}
function Jt() {
  return $.base;
}
function Kt(t, r, e) {
  var a = E({}, $.base, $[r]), n = r === "header" ? t.alignment : e.alignment;
  return n && (a.alignment = n), e.bold && r !== "header" && (a.font = E({}, a.font, {
    style: "bold"
  })), a;
}
function Qt(t, r) {
  if (g(r)) {
    if (yt(t))
      return xt.format(t, r);
    if (rt(t))
      return Wt.format(t, r);
  }
  return t == null ? void 0 : t.toString();
}
var Zt = ["_rect", "gridCell"];
function ut(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function C(t) {
  return Math.round(1e3 * t) / 1e3;
}
function It(t, r, e, a) {
  e.forEach((n) => {
    var {
      _rect: o,
      gridCell: i
    } = n, l = Et(n, Zt), {
      x: d,
      y: s,
      w: v,
      h: u
    } = o, p = {
      x: d,
      y: s,
      w: v,
      h: u
    }, h = {
      doc: t,
      rect: p,
      pdfCell: l,
      gridCell: i,
      cancel: !1
    };
    r == null || r(h), h.cancel || (rr(t, n), er(t, n, a));
  });
}
function q(t, r, e, a, n) {
  t.line(C(r), C(e), C(a), C(n));
}
function wt(t, r, e, a, n, o) {
  g(o) ? t.rect(C(r), C(e), C(a), C(n), o) : t.rect(C(r), C(e), C(a), C(n));
}
function $t(t) {
  return (t.getLineHeightFactor() - 1.15) * t.getFontSize();
}
function tr(t, r, e, a, n, o) {
  var i = r.split(`
`), l = i.length, d = k(t, i[0], t.getFont(), {
    wordWrapEnabled: !1,
    targetRectWidth: 1e9
  }), s = a ?? "middle", v = n ?? "left", u = {
    top: 0,
    middle: 0.5,
    bottom: 1
  }, p = e.y + e.h * u[s] - d * (l - 1) * u[s] + $t(t), h = e.x + e.w * {
    left: 0,
    center: 0.5,
    right: 1
  }[v], m = et({
    baseline: s,
    align: v
  }, o);
  t.text(i.join(`
`), C(h), C(p), m);
}
function rr(t, r) {
  g(r.backgroundColor) && (it(t, "fill", r.backgroundColor), wt(t, r._rect.x, r._rect.y, r._rect.w, r._rect.h, "F"));
}
function er(t, r, e) {
  if (g(r.text) && r.text !== "") {
    var {
      textColor: a,
      font: n,
      _rect: o,
      padding: i
    } = r;
    or(t, {
      textColor: a,
      font: n
    }, e);
    var l = {
      x: o.x + i.left,
      y: o.y + i.top,
      w: o.w - (i.left + i.right),
      h: o.h - (i.top + i.bottom)
    };
    if (g(r._textLeftOffset) || g(r._textTopOffset)) {
      var d, s;
      l.x = l.x + ((d = r._textLeftOffset) !== null && d !== void 0 ? d : 0), l.y = l.y + ((s = r._textTopOffset) !== null && s !== void 0 ? s : 0), t.saveGraphicsState(), vr(t, r._rect.x, r._rect.y, r._rect.w, r._rect.h);
    }
    tr(t, r.text, l, r.verticalAlign, r.horizontalAlign, r._internalTextOptions), (g(r._textLeftOffset) || g(r._textTopOffset)) && t.restoreGraphicsState();
  }
}
function ar(t, r, e) {
  r.filter((a) => !g(a.borderColor)).forEach((a) => {
    tt(t, a._rect, a, e);
  }), r.filter((a) => g(a.borderColor)).forEach((a) => {
    tt(t, a._rect, a, e);
  });
}
function nr(t, r, e, a) {
  tt(t, r, e, a);
}
function tt(t, r, e, a) {
  var {
    borderWidth: n,
    borderColor: o,
    drawLeftBorder: i = !0,
    drawRightBorder: l = !0,
    drawTopBorder: d = !0,
    drawBottomBorder: s = !0
  } = e;
  if (!g(r))
    throw "rect is required";
  !i && !l && !d && !s || (i && l && d && s ? (ht(t, {
    borderWidth: n,
    borderColor: o
  }, a), wt(t, r.x, r.y, r.w, r.h)) : (ht(t, {
    borderWidth: n,
    borderColor: o
  }, a), d && q(t, r.x, r.y, r.x + r.w, r.y), i && q(t, r.x, r.y, r.x, r.y + r.h), l && q(t, r.x + r.w, r.y, r.x + r.w, r.y + r.h), s && q(t, r.x, r.y + r.h, r.x + r.w, r.y + r.h)));
}
function or(t, r, e) {
  var {
    textColor: a,
    font: n
  } = r;
  it(t, "text", g(a) ? a : e.textColor);
  var o = g(n) ? et({}, e.font, n) : e.font, i = t.getFont();
  (o.name !== i.fontName || o.style !== i.fontStyle || g(o.weight)) && t.setFont(o.name, o.style, o.weight), o.size !== t.getFontSize() && t.setFontSize(o.size);
}
function ht(t, r, e) {
  var {
    borderWidth: a,
    borderColor: n
  } = r, o = g(a) ? a : e.borderWidth;
  o !== lt(t) && bt(t, U(t, o)), it(t, "draw", g(n) ? n : e.borderColor);
}
function it(t, r, e) {
  var a = "get".concat(ut(r), "Color"), n = "set".concat(ut(r), "Color"), {
    ch1: o = e,
    ch2: i,
    ch3: l,
    ch4: d
  } = e, s = t.__private__.decodeColorString(t.__private__.encodeColorString({
    ch1: o,
    ch2: i,
    ch3: l,
    ch4: d,
    precision: r === "text" ? 3 : 2
  }));
  (s !== t[a]() || r === "fill") && t[n].apply(t, [o, i, l, d].filter((v) => v !== void 0));
}
function ir(t) {
  var r = t.getFont();
  return {
    borderWidth: lt(t),
    borderColor: t.getDrawColor(),
    font: {
      name: r.fontName,
      style: r.fontStyle,
      size: t.getFontSize()
    },
    textColor: t.getTextColor()
  };
}
function lr(t, r) {
  var {
    borderWidth: e,
    borderColor: a,
    font: n,
    textColor: o
  } = r, i = t.getFont();
  (i.fontName !== n.name || i.fontStyle !== n.style) && t.setFont(n.name, n.style, void 0);
  var l = t.getFontSize();
  l !== n.size && t.setFontSize(n.size), lt(t) !== e && bt(t, e), t.getDrawColor() !== a && t.setDrawColor(a), t.getTextColor() !== o && t.setTextColor(o);
}
function fr(t) {
  t.addPage(), dr(t);
}
function lt(t) {
  var r;
  return g(t.getLineWidth) ? t.getLineWidth() : (r = t.__borderWidth) !== null && r !== void 0 ? r : 0.200025;
}
function bt(t, r) {
  t.setLineWidth(r), g(t.getLineWidth) || (t.__borderWidth = r);
}
function dr(t) {
  g(t.getLineWidth) || (t.__borderWidth = null);
}
function vr(t, r, e, a, n) {
  t.moveTo(C(r), C(e)), t.lineTo(C(r + a), C(e)), t.lineTo(C(r + a), C(e + n)), t.lineTo(C(r), C(e + n)), t.clip(), t.discardPath();
}
var ct = (t) => (t == null ? void 0 : t.sourceCellInfo.gridCell.rowType) === "header", ur = (t, r, e, a, n) => {
  for (var [o, i] = a(r, t), l = [r ? o.map((d) => E({}, d, {
    y: e
  })) : o]; !n(!1, i[0].h); )
    [o, i] = a(!1, i), l.push(o);
  return [l, i];
}, hr = (t, r, e) => {
  r.forEach((i, l) => {
    i.sourceCellInfo.text = e[l].sourceCellInfo.text, i.h = e[l].h;
  });
  var a = t.indexOf(r[r.length - 1]) + 1;
  if (!(a >= t.length))
    for (var n = t[a].y - (r[0].y + e[0].h), o = a; o < t.length; o++)
      t[o].y = t[o].y - n;
}, sr = (t, r) => r && ct(t[t.length - 1]), gr = (t, r, e, a, n) => {
  if (!a)
    return [];
  var o = t[t.length - 1], i = r[t.length];
  if (!i || ct(i))
    return [];
  var l = n(e, i.h);
  if (l && !e)
    return [];
  var d = r.filter((p) => {
    var {
      y: h
    } = p;
    return h === i.y;
  }), s = o.y + o.h, [v, u] = ur(d, e, s, a, n);
  return hr(r, d, u), v;
};
function V(t, r, e) {
  return E({}, t, {
    sourceCellInfo: E({}, t.sourceCellInfo, {
      text: r
    }),
    y: e
  });
}
var pr = (t, r, e, a) => (n, o) => {
  var i = [], l = [], d = 0, s = 0;
  return o.forEach((v) => {
    var {
      w: u,
      sourceCellInfo: p
    } = v, h = !n && r.repeatHeaders ? e : e + r.topLeft.y, m = M(t, p.text, p.font).h, y = p.padding.top + p.padding.bottom, _ = a.y - h - y - r.margin.top, b = Math.floor(_ / (m * t.getLineHeightFactor())), x = nt(t, p.text, p.font, {
      wordWrapEnabled: p.wordWrapEnabled,
      targetRectWidth: u
    });
    if (b < x.length) {
      var w = x.slice(0, b).join(`
`), f = k(t, w, p.font, {
        wordWrapEnabled: p.wordWrapEnabled,
        targetRectWidth: u
      });
      d = Math.max(d, f + y), s = v.h - f, i.push(V(v, w, r.margin.top)), l.push(V(v, x.slice(b).join(`
`), r.margin.top));
    } else {
      var c = k(t, p.text, p.font, {
        wordWrapEnabled: p.wordWrapEnabled,
        targetRectWidth: u
      });
      d = Math.max(d, c + y), s = Math.max(s, c + y), i.push(V(v, p.text, r.margin.top)), l.push(V(v, "", r.margin.top));
    }
  }), i.forEach((v) => v.h = d), l.forEach((v) => v.h = s), [i, l];
}, st = 1e-3;
function gt(t) {
  return [].concat.apply([], t.map((r) => r.cells.filter((e) => !g(e.pdfCell.isMerged)).map((e) => E({}, e.pdfCell._rect, {
    sourceCellInfo: E({}, e.pdfCell, {
      gridCell: e.gridCell
    })
  }))));
}
function mr(t, r, e, a, n) {
  if (r.length === 0)
    return [
      []
    ];
  var o = {
    x: at(t) - e.margin.right,
    y: Lt(t) - e.margin.bottom
  }, i = r.filter((h) => h.rowType === "header"), l = i.reduce((h, m) => h + m.height, 0), d = pt(gt(r), e.margin.top, "y", "h", (h, m) => {
    var y = !h && e.repeatHeaders ? l : 0;
    return C(m + y) <= C(o.y);
  }, (h, m, y, _) => {
    var b = {
      sourceRect: h,
      topRect: {
        x: h.x,
        y: h.y,
        w: h.w,
        h: m - h.y
      },
      bottomRect: {
        x: h.x,
        y: m,
        w: h.w,
        h: h.h - (m - h.y)
      }
    };
    n(b), y.push(b.topRect), _.push(b.bottomRect);
  }, pr(t, e, l, o));
  if (e.repeatHeaders)
    for (var s = 1; s < d.length; s++) {
      d[s].forEach((h) => h.y += l);
      var v = gt(i);
      v.forEach((h) => {
        h.y -= e.topLeft.y;
      }), d[s] = [...v, ...d[s]];
    }
  for (var u = 0; u < d.length; ) {
    var p = pt(d[u], e.margin.left, "x", "w", (h, m) => C(m) <= C(o.x), (h, m, y, _) => {
      var b = {
        sourceRect: h,
        leftRect: {
          x: h.x,
          y: h.y,
          w: m - h.x,
          h: h.h
        },
        rightRect: {
          x: m,
          y: h.y,
          w: h.w - (m - h.x),
          h: h.h
        }
      };
      a(b), y.push(b.leftRect), _.push(b.rightRect);
    });
    p.length > 1 ? (d.splice(u, 1, ...p), u += p.length) : u += 1;
  }
  return d.map((h) => h.map((m) => E({}, m.sourceCellInfo, {
    _rect: m
  })));
}
function pt(t, r, e, a, n, o, i) {
  for (var l = [], d = [...t], s = (u, p) => n(u, p + r), v = function() {
    var u = 0, p = d.filter((w) => {
      var f = w[e] + w[a];
      return n(l.length === 0, f) ? (u <= f && (u = f), !0) : !1;
    }), h = sr(p, l.length === 0), m = gr(p, d, h, i, s), y = d.filter((w) => {
      var f = w[e], c = w[e] + w[a];
      return u - f > st && c - u > st;
    });
    y.forEach((w) => {
      o(w, u, p, d);
      var f = d.indexOf(w);
      f !== -1 && d.splice(f, 1);
    }), p.forEach((w) => {
      var f = d.indexOf(w);
      f !== -1 && d.splice(f, 1);
    }), d.forEach((w) => {
      w[e] = g(u) ? w[e] - u + r : w[e];
    });
    var _ = h && m.length > 0;
    if (_) {
      var [b, ...x] = m;
      l.push([...p, ...b]), l.push(...x);
    } else if (p.length > 0)
      l.push(p), l.push(...m);
    else if (m.length > 0)
      l.push(...m), l.push(d);
    else
      return l.push(d), 1;
  }; d.length > 0 && !v(); )
    ;
  return l;
}
function wr(t) {
  var {
    jsPDFDocument: r
  } = t, e = et({}, t);
  return g(e.topLeft) || (e.topLeft = {
    x: 0,
    y: 0
  }), g(e.indent) || (e.indent = 0), g(e.repeatHeaders) || (e.repeatHeaders = !0), g(e.margin) || (e.margin = U(r, 40)), e.margin = mt(e.margin), Array.isArray(e.columnWidths) || (e.columnWidths = []), g(e.loadPanel) || (e.loadPanel = {}), g(e.loadPanel.enabled) || (e.loadPanel.enabled = !0), g(e.loadPanel.text) || (e.loadPanel.text = _t.format("dxDataGrid-exporting")), e;
}
function br(t) {
  var r, {
    jsPDFDocument: e,
    component: a,
    selectedRowsOnly: n,
    loadPanel: o
  } = t, i = ((r = a._getInternalInstance) === null || r === void 0 ? void 0 : r.call(a)) || a, l = i.option("loadPanel") && i.option("loadPanel").enabled;
  l && a.option("loadPanel.enabled", !1);
  var d;
  if (o.enabled && dt()) {
    var s = a.getView("rowsView");
    d = new Pt(a, s.element(), s.element().parent(), o), d.show();
  }
  var v = a.getDataProvider(n);
  return new Promise((u) => {
    v.ready().done(() => {
      var p, h, m = Xt(e, v, a, (p = t.rowOptions) === null || p === void 0 || (h = p.headerStyles) === null || h === void 0 ? void 0 : h.backgroundColor);
      t.customizeCell && m.forEach((x) => x.cells.forEach((w) => t.customizeCell(w))), Dt(m), Bt(e, v, m, t), Gt(m, t), Ht(m), Tt(e, m, t), jt(m), qt(e, m), kt(e, m, t), Mt(m), Ot(e, m);
      var y = ir(e), _ = !!a.option("rtlEnabled"), b = mr(e, m, t, (x) => {
        var w, {
          sourceRect: f,
          leftRect: c,
          rightRect: W
        } = x, L = {}, S = {}, B = ((w = f.sourceCellInfo.text) === null || w === void 0 ? void 0 : w.length) > 0;
        if (B)
          if (_) {
            var O = e.getTextWidth(f.sourceCellInfo.text) > c.w, X = !g(f.sourceCellInfo.horizontalAlign) || f.sourceCellInfo.horizontalAlign === "right";
            if (O || !X) {
              var T, R, A, D, P;
              if (((T = f.sourceCellInfo) === null || T === void 0 ? void 0 : T.horizontalAlign) === "right") {
                var F;
                D = (F = f.sourceCellInfo._textLeftOffset) !== null && F !== void 0 ? F : 0, P = D + c.w;
              } else
                ((R = f.sourceCellInfo) === null || R === void 0 ? void 0 : R.horizontalAlign) === "center" ? (P = f.x + f.w - (W.x + W.w) + f.sourceCellInfo._rect.w / 2 - c.w / 2, D = P - W.w) : ((A = f.sourceCellInfo) === null || A === void 0 ? void 0 : A.horizontalAlign) === "left" && (P = f.x + f.w - (W.x + W.w), D = P - W.w);
              L = E({}, {
                _textLeftOffset: D
              }), S = E({}, {
                _textLeftOffset: P
              });
            } else
              S = E({}, {
                text: ""
              });
          } else {
            var H = e.getTextWidth(f.sourceCellInfo.text) > c.w, j = !g(f.sourceCellInfo.horizontalAlign) || f.sourceCellInfo.horizontalAlign === "left";
            if (H || !j) {
              var z, Y, J, G, N;
              if (((z = f.sourceCellInfo) === null || z === void 0 ? void 0 : z.horizontalAlign) === "left") {
                var K;
                G = (K = f.sourceCellInfo._textLeftOffset) !== null && K !== void 0 ? K : 0, N = G - c.w;
              } else if (((Y = f.sourceCellInfo) === null || Y === void 0 ? void 0 : Y.horizontalAlign) === "center") {
                var Q, ft = (Q = f.sourceCellInfo._textLeftOffset) !== null && Q !== void 0 ? Q : 0;
                G = ft + (f.x + f.w / 2) - (c.x + c.w / 2), N = ft + (f.x + f.w / 2) - (W.x + W.w / 2);
              } else
                ((J = f.sourceCellInfo) === null || J === void 0 ? void 0 : J.horizontalAlign) === "right" && (G = f.x + f.w - (c.x + c.w), N = f.x + f.w - (W.x + W.w));
              L = E({}, {
                _textLeftOffset: G
              }), S = E({}, {
                _textLeftOffset: N
              });
            } else
              S = E({}, {
                text: ""
              });
          }
        c.sourceCellInfo = E({}, f.sourceCellInfo, {
          debugSourceCellInfo: f.sourceCellInfo
        }, L), W.sourceCellInfo = E({}, f.sourceCellInfo, {
          debugSourceCellInfo: f.sourceCellInfo
        }, S);
      }, (x) => {
        var w, {
          sourceRect: f,
          topRect: c,
          bottomRect: W
        } = x, L = {}, S = {}, B = ((w = f.sourceCellInfo.text) === null || w === void 0 ? void 0 : w.length) > 0;
        if (B) {
          var O, X = e.getTextDimensions(f.sourceCellInfo.text).h > c.h, T = ((O = f.sourceCellInfo) === null || O === void 0 ? void 0 : O.verticalAlign) === "top";
          if (X || !T) {
            var R, A, D, P, F;
            if (((R = f.sourceCellInfo) === null || R === void 0 ? void 0 : R.verticalAlign) === "top") {
              var H;
              P = (H = f.sourceCellInfo._textTopOffset) !== null && H !== void 0 ? H : 0, F = P - c.h;
            } else if (((A = f.sourceCellInfo) === null || A === void 0 ? void 0 : A.verticalAlign) === "middle") {
              var j, z = (j = f.sourceCellInfo._textTopOffset) !== null && j !== void 0 ? j : 0;
              P = z + (f.y + f.h / 2) - (c.y + c.h / 2), F = z + (f.y + f.h / 2) - (W.y + W.h / 2);
            } else
              ((D = f.sourceCellInfo) === null || D === void 0 ? void 0 : D.verticalAlign) === "bottom" && (P = f.y + f.h - (c.y + c.h), F = f.y + f.h - (W.y + W.h));
            L = E({}, {
              _textTopOffset: P
            }), S = E({}, {
              _textTopOffset: F
            });
          } else
            S = E({}, {
              text: ""
            });
        }
        c.sourceCellInfo = E({}, f.sourceCellInfo, {
          debugSourceCellInfo: f.sourceCellInfo
        }, L), W.sourceCellInfo = E({}, f.sourceCellInfo, {
          debugSourceCellInfo: f.sourceCellInfo
        }, S);
      });
      _ && Rt(e, b, t), b.forEach((x, w) => {
        w > 0 && fr(e), It(e, t.customDrawCell, x, y), ar(e, x, y);
        var f = g(x) && x.length === 0;
        if (f) {
          var c = Nt(e, x, t), W = Jt();
          nr(e, c, W, y);
        }
      }), lr(e, y), u();
    }).always(() => {
      l && a.option("loadPanel.enabled", l), o.enabled && dt() && d.dispose();
    });
  });
}
var Ct = {
  getFullOptions: wr,
  export: br
}, cr = "https://supportcenter.devexpress.com/ticket/details/t1077554";
function Cr(t) {
  if (!(g(t) && Z(t)))
    throw Error('The "exportDataGrid" method requires a configuration object.');
  if (!(g(t.component) && Z(t.component) && t.component.NAME === "dxDataGrid"))
    throw Error('The "component" field must contain a DataGrid instance.');
  if (!(g(t.jsPDFDocument) && Z(t.jsPDFDocument)))
    throw Error('The "jsPDFDocument" field must contain a jsPDF instance.');
  return g(t.autoTableOptions) && St.log("W0001", "Export", "autoTableOptions", "22.1", "You can migrate from exporting to PDF with the AutoTable plugin to a new export system. See the following topic for more information: ".concat(cr)), Ct.getFullOptions(t);
}
function Er(t) {
  return Ct.export(Cr(t));
}
export {
  Er as default
};
//# sourceMappingURL=pdf-exporter-CvDOFuac.mjs.map
